import {
  AccountContact,
  AccountContactType
} from "@/components/Contracts/ConfirmationStep/Signature/signature.interface";

export const buildAccountContacts = (
  accountContacts: Array<AccountContact>,
  requiredContactTypes: Array<AccountContactType>
) => {
  const accountContactsWithValue = accountContacts?.filter(
    accountContact => accountContact?.contactType || accountContact?.contact
  );

  if (!accountContactsWithValue?.length) {
    return requiredContactTypes.map(contactType => ({
      contactType,
      contact: ""
    }));
  }

  const requiredAccountContacts = requiredContactTypes.map(contactType => {
    return (
      accountContactsWithValue.find(
        accountContact =>
          accountContact.contactType === contactType && accountContact.contact
      ) ??
      accountContactsWithValue.find(
        accountContact => accountContact.contactType === contactType
      ) ?? {
        id: null,
        contactType,
        contact: ""
      }
    );
  });

  const optionalContacts = accountContactsWithValue.filter(
    accountContact =>
      !requiredAccountContacts.includes(accountContact) &&
      accountContact.contactType &&
      accountContact.contact
  );

  return [...requiredAccountContacts, ...optionalContacts];
};
